import React from 'react';
import {getContainer} from '../../ioc/IOCSetup';
import "../SportsView.scss";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import Page from "../../layout/Page";
import {fetchSettings} from "../../settings/SettingsActions";
import {AppState} from "../../RootReducer";
import {LaunchUrl, Settings} from "../../http/protocol";
import {LoginStatus} from '../../http/Types';
import {ContentModelName, PopupManager} from "../../contenful/types";
import {fetchContent} from "../../contenful/ContentfulActions";
import {ReactComponent as Spinner} from "../../assets/ball_loader.svg";
import {progressBar} from "../../utils/ProgressBar";


type Props = {
    settings : Settings,
    fetchSettings : typeof fetchSettings,
    loggedIn?: boolean;
    currency?: string;
    popupManager?: PopupManager;
    fetchContent : typeof fetchContent;
    lng: string;
};

interface State {
    sportsbookUrl?: string;
    iframeHeight?: number;
    loading:boolean;
    progress:number;
    manualProgressIncrease:boolean;
}

export class Song88SportsComponent extends React.Component<Props, State>{
    listener: any;
    progressInterval: any;
    constructor(props : Props){
        super(props);
        this.state = { iframeHeight : 1800, loading:true, progress: 0, manualProgressIncrease:true };
    }
    startProgress () {
        if(this.progressInterval) {
            clearInterval(this.progressInterval);
        }
        let current_progress:number = 0;
        let step:number = 0.1;
        this.setState({ loading: true, progress:0, sportsbookUrl: undefined, manualProgressIncrease :true})
        this.progressInterval = setInterval(() => {
            if(this.state.manualProgressIncrease) {
                current_progress += step;
                let progress:number = Math.round(Math.atan(current_progress) / (Math.PI / 2) * 98 * 1000) / 1000;
                if(this.state.progress > 35) {
                    step = 0.4
                }
                this.setState({progress:progress})
            }
        }, 200);
    }
    componentDidMount(): void {
        setTimeout(() => {
            this.setState({loading:false})
        },30000)
       this.startProgress();

        window.addEventListener("message", (e:any) => {
            if(e.data.isLoaded) {
                this.setState({progress: 100, manualProgressIncrease:false})
                setTimeout(()=>this.setState({loading:false, progress: 100, manualProgressIncrease:false}, () => clearInterval(this.progressInterval)),250)
            }
        });
        // if(this.props.popupManager == undefined) {
        //     this.props.fetchContent(ContentModelName.POPUPMANAGER, this.props.lng);
        // }else {
        //     this.setState({ hideAfterWentToOtherPage: true })
        // }
        this.listener = window.addEventListener("message", (e)=> {
            try {
                try {
                    if(e.data.frameHeight) {
                        let iframe = parseInt(""+e.data.frameHeight)
                        if(iframe < 2000) {
                            iframe = 2000;
                        } else {
                            //iframe + 200;
                        }
                        this.setState({ iframeHeight : iframe})
                    }
                } catch (e) {
                }


            } catch (e) {
                console.log(e);
            }
        },false);

        if(this.props.settings == undefined) {
            this.props.fetchSettings();
        }


        const currencyOnLoad = this.props.currency || "";
        let locale = getContainer().getSettingsService().getActiveLocale().code;

        if(this.props.loggedIn) {
            getContainer().getSportsbookService().getSong88GameLaunchUrl(currencyOnLoad, locale).then((r : LaunchUrl)=>{
                this.setState({ sportsbookUrl : r.url });
            });
        }
        if(!this.props.loggedIn) {
            getContainer().getSportsbookService().getSong88AnonymousGameLaunchUrl(currencyOnLoad, locale).then((r : LaunchUrl)=>{
                this.setState({ sportsbookUrl : r.url });
            });
        }
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        let locale = getContainer().getSettingsService().getActiveLocale().code;
        if(prevProps.loggedIn != this.props.loggedIn && this.props.currency != undefined) {
            if(this.props.loggedIn) {
                getContainer().getSportsbookService().getSong88GameLaunchUrl(this.props.currency, locale).then((r : LaunchUrl)=>{
                    this.setState({ sportsbookUrl : r.url , loading: true, progress : 0}, () => this.startProgress());
                });
            } else {
                getContainer().getSportsbookService().getSong88AnonymousGameLaunchUrl(this.props.currency, locale).then((r : LaunchUrl)=>{
                    this.setState({ sportsbookUrl : r.url , loading: true, progress : 0}, () => this.startProgress());
                });
            }
        }

        if((this.state.sportsbookUrl == undefined && this.props.currency != undefined)) {
            if(this.props.loggedIn) {
                getContainer().getSportsbookService().getSong88GameLaunchUrl(this.props.currency, locale).then((r : LaunchUrl)=>{
                    this.setState({ sportsbookUrl : r.url }, () => {
                    });
                });
            } else {
                getContainer().getSportsbookService().getSong88AnonymousGameLaunchUrl(this.props.currency, locale).then((r : LaunchUrl)=>{
                    this.setState({ sportsbookUrl : r.url });
                });
            }
        } else if (this.props.currency != prevProps.currency && this.props.currency != undefined) {
            this.startProgress();
        }
    }

    componentWillUnmount(): void {
        window.removeEventListener("message", this.listener);
    }

    loadContent() {
        return(
            <iframe
                hidden={this.state.loading}
                id="sportsbook-iframe"
                scrolling="no"
                width={"100%"}
                height={this.state.iframeHeight}
                className={"sportsbook-iframe"}
                frameBorder={0}
                allowFullScreen={false}
                src={this.state.sportsbookUrl}/>
        )
    }

    render() {
        return (
            <div>
                {this.state.loading && <div className="preloader">
                    <Spinner/>
                    {progressBar(this.state.progress, "100px", "2px")}
                </div>}
                <Page>
                    {this.loadContent()}
                </Page>
            </div>
        )
    }
}

const stateToProps = (app : AppState) => {
    return {
        settings: app.settings.settings ? app.settings.settings : {},
        loggedIn : app.user.status == LoginStatus.LOGGED_IN,
        currency: app.user.activeCurrency,
        popupManager: app.contentful.popupManager,
    }
};

const dispatchToProps = (dispatch : Dispatch) => (
    {
        fetchSettings : () => dispatch(fetchSettings() as any),
        fetchContent : (contentModelName : ContentModelName) => dispatch(fetchContent(contentModelName) as any),

    }
);
export default connect(stateToProps, dispatchToProps)(Song88SportsComponent)

